/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { bmsversion } from '../../bmsversion.js';

export const environment = {
  production: false,
  apiUrl: window["env"]["apiUrl"] || "default",
  debug: window["env"]["debug"] || false,
  version: bmsversion || "brak",
  // Entra ID / Azure AD Configuration
  azureAuth: {
    clientId: window["env"]["azureClientId"],
    authority: `https://login.microsoftonline.com/common`,
    redirectUri: window.location.origin+'/auth/login',
  }
};